import apiSportsSchools from '@/api/sports-schools'

const state = {
    validationErrors: null,
    isSubmitting: false
}

export const mutationTypes = {
    deleteSportSchoolsStart: '[delete sportsSchools] deleteSportSchoolsStart',
    deleteSportSchoolsSuccess: '[delete sportsSchools] deleteSportSchoolsSuccess',
    deleteSportSchoolsFailure: '[delete sportsSchools] deleteSportSchoolsFailure'
}

export const actionType = {
    deleteSportSchools: '[delete sportsSchools] deleteSportSchools'
}

const mutations = {
    [mutationTypes.deleteSportSchoolsStart](state) {
        state.isSubmitting = true
        state.validationErrors = null
    },

    [mutationTypes.deleteSportSchoolsSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.deleteSportSchoolsFailure](state, payload) {
        state.isSubmitting = false
        state.validationErrors = payload
    }
}

const actions = {
    [actionType.deleteSportSchools](context, {id}) {
        context.commit(mutationTypes.deleteSportSchoolsStart)
        return new Promise(resolve => {
            apiSportsSchools
                .deleteSportSchool(id)
                .then(response => {
                    context.commit(mutationTypes.deleteSportSchoolsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.deleteSportSchoolsFailure,
                        result.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
